<template>
  <div>
    <div class="headerButtons">
      <div class="headerButtons__backButton">
        <b-button variant="outline-primary" @click="$router.go(-1)">
            Назад
        </b-button>
      </div>
    </div>
    <div class="groupTraining">
      <!-- Заголовок -->
      <div class="groupTraining__trainerTitle">
        <h3>
          {{trainingName}}
        </h3>
      </div>
      <div class="groupTraining__steps mt-4">
        <h4>
            Выбор этапов
        </h4>
        <b-form-checkbox-group  @input="checkCopiesForDefault"
          v-if="optionsSteps.length > 0" v-model="selectedSteps">
          <div
            class="mt-3"
            v-for="(option, index) in optionsSteps"
            :key="index"
          >
            <b-form-checkbox
              :value="option.value"
            >
              {{ option.text }}
            </b-form-checkbox>
          </div>
        </b-form-checkbox-group>
        <p v-else>В тренажере отсутствуют этапы</p>
      </div>
      <div class="groupTraining__emergencySituations mt-4">
        <h4>
            Выбор нештатных ситуаций
        </h4>
        <b-form-checkbox-group v-if="optionsEmergencySituations.length > 0"
          v-model="selectedEmergencySituations" @input="checkCopiesForEmergency"
        >
          <div
            class="mt-3"
            v-for="(option, index) in optionsEmergencySituations"
            :key="index"
          >
            <b-form-checkbox
              :value="option.value"
            >
              {{ option.text }}
            </b-form-checkbox>
          </div>
        </b-form-checkbox-group>
        <p style="color: #0078c1;" class="mt-3"
          v-else
        >
          В тренажере отсутствуют нештатные ситуации
        </p>
      </div>
      <!-- Таблица -->
      <div class="groupTraining__roleTable mt-4">
        <h4>
            Назначение ролей
        </h4>
        <div class="groupTraining__table" ref="gridDiv">
          <ag-grid-vue
            style="width: 100%; height: 100%;"
            class="ag-theme-material ag-grid-vue-progress"
            rowHeight="100"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            :rowData="students"
            :suppressPaginationPanel="true"
            :context="context"
            :frameworkComponents="frameworkComponents"
            @grid-ready="onGridReady"
            @gridSizeChanged="onGridSizeChanged"
          >
          </ag-grid-vue>
        </div>
      </div>
      <div class="groupTraining__launchButtons mb-3 mt-4">
        <b-button
          :disabled="selectedSteps.length === 0
            || !areRolesOk"
          @click="onEducationClick"
          variant="primary" class="mr-3"
        >
          Обучение
        </b-button>
        <b-button
          :disabled="selectedSteps.length === 0
            || !areRolesOk"
          @click="onTestingClick"
          variant="primary"
        >
          Тестирование
        </b-button>
      </div>
    </div>
    <training-approve-modal />
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

import { mapMutations, mapGetters, mapActions } from 'vuex'

import RoleSelectRenderer from '@/components/helpers/renderers/RoleSelectRenderer'
import TeamSelectRenderer from '@/components/helpers/renderers/TeamSelectRenderer'

import TrainingApproveModal from '@/components/content/education/training/modals/TrainingApproveModal.vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

function indexFormatter(params) {
  return params.node.rowIndex + 1
}

function nameFormatter(params) {
  return params.data ? `${params.data.surname} ${params.data.name.slice(0, 1)}. ${params.data.midname.slice(0, 1)}.` : ''
}

export default {
  name: 'TrainerGroupTraining',
  components: {
    'ag-grid-vue': AgGridVue,
    TrainingApproveModal
  },
  props: {
    editMode: Boolean
  },
  data() {
    return {
      selectedSteps: [],
      optionsSteps: [],
      selectedEmergencySituations: [],
      optionsEmergencySituations: [],
      trainingData: [],
      frameworkComponents: {
        roleSelectRenderer: RoleSelectRenderer,
        teamSelectRenderer: TeamSelectRenderer
      },
      columnDefs: [
        {
          headerName: '№',
          field: 'surname',
          headerClass: 'ag-grid-table-header',
          valueFormatter: indexFormatter,
          width: 100
        },
        {
          headerName: 'Ф.И.О.',
          field: 'name',
          headerClass: 'ag-grid-table-header',
          valueFormatter: nameFormatter
        },
        {
          headerName: 'Роль',
          field: 'role',
          headerClass: 'ag-grid-table-header',
          cellRenderer: 'roleSelectRenderer'
        },
        {
          headerName: 'Команда',
          field: 'group',
          headerClass: 'ag-grid-table-header',
          cellRenderer: 'teamSelectRenderer'
        }
      ],
      gridApi: null,
      columnApi: null,
      autoGroupColumnDef: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: false
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      context: {
        componentParent: this
      },
      rowGroupPanelShow: null,
      pivotPanelShow: null
    }
  },
  created() {
    if (!this.trainingCourse) {
      this.fetchTrainingContent(this.$route.params.trainingId).then(() => {
        this.setSettings()
        this.setSockets()
      })
    } else {
      this.setSettings()
      this.setSockets()
    }
    this.setGroupTrainingSettings([])
  },
  beforeRouteLeave(to, from, next) {
    this.removeConnection()
    this.setGroupTrainingSettings([])
    this.setGroupTrainingStudents([])
    this.setGroupTrainingTeams([])

    next()
  },
  computed: {
    ...mapGetters({
      trainingCourse: 'training/getTrainingCourse',
      trainingTeams: 'educationStudentsManagement/getGroupTrainingTeams',
      currUser: 'currentUser/getCurrentUser',
      students: 'educationStudentsManagement/getGroupTrainingStudents',
      isSocketReady: 'socket/isSocketReady'
    }),
    trainingName() {
      return (this.trainingCourse)
        ? this.trainingCourse.name : ''
    },
    areRolesOk() {
      if (this.trainingTeams.length > 0) {
        let unique = true
        this.trainingTeams.forEach((t) => {
          t.roles.map((r) => r.role).forEach((r) => {
            if (r) {
              const k = t.roles.map((rr) => rr.role).indexOf(r)
            !== t.roles.map((rr) => rr.role).lastIndexOf(r)
              if (k && t.roles.length > 1) {
                unique = false
              }
            }
          })
        })
        return unique
      }

      return true
    }
  },
  methods: {
    ...mapActions({
      fetchTrainingContent: 'training/fetchTrainingContent',
      sendMessage: 'socket/sendMessage'
    }),
    ...mapMutations({
      setGroupTrainingSettings: 'educationStudentsManagement/setGroupTrainingSettings',
      setGroupTrainingStudents: 'educationStudentsManagement/setGroupTrainingStudents',
      setGroupTrainingTeams: 'educationStudentsManagement/setGroupTrainingTeams',
      setGroupTrainingMode: 'educationStudentsManagement/setGroupTrainingMode',
      addStudents: 'educationStudentsManagement/addStudents',
      removeStudents: 'educationStudentsManagement/removeStudents',
      setNewConnection: 'socket/setNewConnection',
      removeConnection: 'socket/removeConnection',
      setOnMessage: 'socket/setOnMessage'
    }),
    checkCopiesForDefault() {
      const name = this.selectedSteps[this.selectedSteps.length - 1]
      this.selectedEmergencySituations.forEach((stageName, index) => {
        const stage = this.trainingCourse.stages.find((st) => st.name === stageName)
        if (stage.stageName === name) {
          this.selectedEmergencySituations.splice(index, 1)
        }
      })
    },
    checkCopiesForEmergency() {
      const lengthEmergency = this.selectedEmergencySituations.length
      const lastName = this.selectedEmergencySituations[lengthEmergency - 1]
      const lastStage = this.trainingCourse.stages.find((st) => st.name === lastName)
      if (lastStage) {
        const defaultStageName = this.trainingCourse.stages
          .find((st) => st.name === lastStage.stageName).name
        this.selectedEmergencySituations.forEach((stageName, index) => {
          const stage = this.trainingCourse.stages.find((st) => st.name === stageName)
          if (this.selectedSteps.includes(stage.stageName)) {
            const stageIndex = this.selectedSteps.indexOf(stage.stageName)
            this.selectedSteps.splice(stageIndex, 1)
          } else if (index !== lengthEmergency - 1 && defaultStageName === stage.stageName) {
            this.selectedEmergencySituations.splice(index, 1)
          }
        })
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
    },
    onGridSizeChanged() {
      this.gridApi.sizeColumnsToFit()
    },
    getGroupStudentsInfo() {
      const info = []
      this.gridApi.forEachNode((node) => {
        info.push(node.data)
      })
      return info
    },
    setTrainingSettings() {
      this.setGroupTrainingStudents(this.getGroupStudentsInfo())
      const stages = []
      this.selectedSteps.forEach((stageName) => {
        stages.push({
          index: this.trainingCourse.stages.indexOf(this.trainingCourse.stages
            .find((st) => st.name === stageName)),
          name: stageName
        })
      })
      this.selectedEmergencySituations.forEach((stageName) => {
        const stage = this.trainingCourse.stages.find((st) => st.name === stageName)
        stages.push({
          index: this.trainingCourse.stages
            .indexOf(this.trainingCourse.stages.find((st) => st.name === stage.stageName)),
          name: stageName
        })
      })
      stages.sort(this.sortByIndex)
      const stagesForTraining = []
      stages.forEach((stage) => {
        stagesForTraining.push(stage.name)
      })
      this.setGroupTrainingSettings({
        stages: stagesForTraining
      })
    },
    sortByIndex(stage1, stage2) {
      return stage1.index - stage2.index
    },
    onEducationClick() {
      this.setTrainingSettings()
      this.setGroupTrainingMode(0)
      this.$bvModal.show('trainingApproveModal')
    },
    onTestingClick() {
      this.setTrainingSettings()
      this.setGroupTrainingMode(1)
      this.$bvModal.show('trainingApproveModal')
    },
    setSettings() {
      this.trainingCourse.stages.forEach((s) => {
        if (s.stageName) {
          this.optionsEmergencySituations.push({
            text: s.name,
            value: s.name
          })
        } else {
          this.optionsSteps.push({
            text: s.name,
            value: s.name
          })
        }
      })
    },
    setSockets() {
      this.setNewConnection()

      const wsSend = () => {
        setTimeout(
          () => {
            if (this.isSocketReady === true) {
              this.setOnMessage((e) => {
                switch (JSON.parse(e.data).action) {
                  case 'trainingRegistration': {
                    this.addStudents(Object.entries(JSON.parse(e.data).data))
                    break
                  }

                  case 'getAwaitingUsers': {
                    this.addStudents(Object.entries(JSON.parse(e.data).data))
                    break
                  }

                  case 'close': {
                    this.removeStudents(Object.entries(JSON.parse(e.data).data))
                    break
                  }
                  default:
                    break
                }
              })


              this.sendMessage({
                action: 'trainingRegistrationAsLeader'
              })
              this.sendMessage({
                action: 'getAwaitingUsers'
              })
            } else {
              wsSend()
            }
          }, 10,
        )
      }

      wsSend()
    }
  }
}
</script>

<style lang="scss" scoped>

.headerButtons {
  width: 100%;
  padding: 20px 0 5px 0;
}

.groupTraining {

  &__filters {
    width: 100%;

    &-organisation {
      width: 78%;
    }

    &-class {
      float: right;
      width: 20%;
    }
  }

  &__table {
    height: calc(100vh - 200px);
    border: 1px solid lightgray;
  }

  &__launchButtons {
    button {
      width: 200px !important;
    }
  }

  &__steps {
    padding-bottom: 10px;
    border-bottom: 1px solid lightgray;
  }

  &__emergencySituations {
    padding-bottom: 10px;
    border-bottom: 1px solid lightgray;
  }

}

</style>
